import paths from 'routes/paths';
import { clearActingProducer, setActingProducerId } from 'helpers/actingProducer';
import { firstAllowedPanelPath } from 'helpers/panelPermissions';

/**
 * Entra no painel de um produtor como membro da equipe. A página recarrega de
 * propósito: o painel precisa subir já falando em nome do produtor, e não
 * misturar o usuário carregado antes com o que a API devolve agora.
 *
 * @param {{ producer_id: number|string, permissions: string[] }} access
 */
export function enterProducerPanel(access) {
    setActingProducerId(access.producer_id);

    window.location.assign(firstAllowedPanelPath(access.permissions) || paths.dashboard.support);
}

export function leaveProducerPanel() {
    clearActingProducer();

    window.location.assign(paths.events.home);
}
